module.exports = __webpack_public_path__ + "img/shop.7c0d423c.png";